module.exports = __webpack_public_path__ + "img/exampleBadge1.52e6a18a.png";